/**
 * parentShellViewModel — ce que le header de la coquille parent lit dans le store.
 *
 * Une valeur, et elle n'est pas nouvelle : le prénom du parent (`formData.user`, chargé par
 * l'accueil ; le compte connecté le porte aussi après une mise à jour d'adresse de facturation).
 * L'adresse du tableau de bord de parrainage n'est plus lue ici : le cœur a quitté le header, et
 * les entrées du parrainage (bandeau de l'accueil, ligne du portail) la lisent dans
 * `referralEntryViewModel`.
 *
 * La LISTE des enfants, elle, ne se recalcule pas ici : `ParentMainLayout` la construit déjà (avec
 * son repli quand aucune famille n'est sélectionnée) et la descend par le contexte. Deux calculs
 * pour une même liste, c'est deux listes qui finissent par différer.
 *
 * Mémoïsé sur la CHAÎNE et non sur les tranches qui la portent : `currentUser.object` change
 * d'identité à chaque rechargement du compte, alors que le prénom du parent, lui, ne bouge
 * presque jamais. Comparer la chaîne garde l'objet rendu stable, donc le header immobile.
 */
import { createSelector } from "reselect"
import { selectAccount } from "../../shared/displayedStudent"

type ParentShellViewModel = {
    parentFirstname: string
}

// Le store est en JS non typé : on lit le champ qu'on connaît, sans le décrire en entier.
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

const selectParentFirstname = (state: ReduxState): string =>
    state?.data?.formData?.user?.parent_firstname ?? selectAccount(state)?.parent_firstname ?? ""

export const parentShellViewModel = createSelector(
    [selectParentFirstname],
    (parentFirstname): ParentShellViewModel => ({ parentFirstname })
)
